import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { adKeys, fetchOurAdApplications } from "hooks/ad";
import { Loader } from "ui/Loader";
import { IntlContext } from "context";
import ApplicationCard from "./ApplicationCard";

const MyApplications: React.FC = () => {
    const intl = useContext(IntlContext);
    const { data: applications = [], isLoading } = useQuery({
        queryKey: adKeys.ourApplications(),
        queryFn: fetchOurAdApplications,
    });

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="rounded-2xl bg-white p-6 shadow-sm sm:p-8">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-gray-900">
                    {intl.formatMessage("profile.my_applications.title")}
                </h2>
                <p className="mt-1 text-sm text-slate-500">
                    {intl.formatMessage("profile.my_applications.count", { count: applications.length })}
                </p>
            </div>

            {applications.length === 0 ? (
                <div className="rounded-lg border border-dashed border-gray-200 bg-slate-50 px-6 py-12 text-center">
                    <p className="text-sm text-slate-600">
                        {intl.formatMessage("profile.my_applications.empty")}
                    </p>
                </div>
            ) : (
                <div className="space-y-4">
                    {applications.map((application) => (
                        <ApplicationCard
                            key={`${application.service_id}-${application.ad_id}`}
                            application={application}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default MyApplications;
